import { useQuery } from '@apollo/client';
import { GetObligationByIdDocument } from '@risksmart-app/web-graphql-client/generated/graphql';

import { useIsFeatureVisibleToOrg } from '@/utils/featureFlags';

import { useGetObligationById as useGetObligationByIdTRPC } from './useGetObligationByIdTRPC';

export const useGetObligationById = (id: string, skip?: boolean) => {
  const trpcEnabled = useIsFeatureVisibleToOrg('trpc');

  // Use TRPC when feature flag is enabled, otherwise use GraphQL
  const trpcResult = useGetObligationByIdTRPC(id, !trpcEnabled || skip);
  const graphqlResult = useQuery(GetObligationByIdDocument, {
    variables: { _eq: id },
    skip: trpcEnabled || skip,
    fetchPolicy: 'no-cache',
  });

  return trpcEnabled ? trpcResult : graphqlResult;
};
